import { render, staticRenderFns } from "./StudioProductCard2.vue?vue&type=template&id=a502c742&scoped=true&"
import script from "./StudioProductCard2.vue?vue&type=script&lang=ts&"
export * from "./StudioProductCard2.vue?vue&type=script&lang=ts&"
import style0 from "./StudioProductCard2.vue?vue&type=style&index=0&id=a502c742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a502c742",
  null
  
)

export default component.exports